export const baseUrl = `${process.env.REACT_APP_API_URL}`;
//Sku catlog category
export const getSkucatlogCategory = baseUrl + "/api/BillPayment/skucatelog";
export const billerSearch = baseUrl + "/api/BillPayment/billers";

//Mapping and Viewing

export const getCategory = baseUrl + "/api/BillPayment/categories";
export const getSubCategory = baseUrl + "/api/BillPayment/subcategories/";
export const getSubCategoryMapping =
  baseUrl + "/api/BillPayment/subcategory-mapping/";
